<template>
  <div class="project-camera-manage">
    <div class="app-control app-table-control">
      <el-button type="primary" @click="add">新增摄像头</el-button>
      <div class="right-region">
        <el-input placeholder="请输入摄像头名称" v-model="search.value" clearable></el-input>
        <el-button type="primary" @click="searchParams">搜索</el-button>
        <el-button @click="resetParams">重置</el-button>
      </div>
    </div>
    <el-table :data="datas" v-loading="loading">
      <el-table-column label="摄像头名称" prop="device_name"></el-table-column>
      <el-table-column label="分辨率" prop="resolution"></el-table-column>
      <el-table-column label="地址" prop="device_attr_data.device_camera_attr_stream_url"></el-table-column>
      <el-table-column label="位置" prop="device_attr_data.device_camera_attr_location"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <el-button type="text" @click="edit(row.device_id)">编辑</el-button>
          <el-button type="text" @click="del(row.device_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
    <el-dialog :title="dialog.title" :visible.sync="dialog.show" center :width="dialogWidth" append-to-body>
      <project-camera-info v-if="dialog.show" :deviceId="deviceId" :cameraId="dialog.id" @submit="initDatas" @cancel="dialog.show = false"></project-camera-info>
    </el-dialog>
  </div>
</template>

<script>
  import ProjectService from '@/io/project.js';
  import ProjectCameraInfo from '@/views/ProjectCameraInfo.vue';

  export default {
    name: 'ProjectCameraManage',
    props: {
      deviceId: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        id: this.$route.params.id,
        search: {
          value: ''
        },
        datas: [],
        loading: false,
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        },
        dialog: {
          show: false,
          title: '',
          id: null
        },
      }
    },
    mounted () {
      this.initDatas();
    },
    components: {
      ProjectCameraInfo,
    },
    methods: {
      initDatas() {
        this.loading = true;
        ProjectService.deviceCameraListPage(
          this.id,
          this.deviceId,
          this.page.currentPage,
          this.search.value
        ).then(res => {
          let source = res.data;
          if (!source.data.length && this.page.currentPage > 1) {
            this.page.currentPage--;
            this.initDatas();
          } else {
            this.datas = source.data.map(val => {
              val.resolution = `${val.device_attr_data.device_camera_attr_resolution_width}*${val.device_attr_data.device_camera_attr_resolution_height}`;
              return val;
            });
            this.page.pageSize = source.per_page;
            this.page.total = source.total;
          }
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      add() {
        this.dialog.title = '新增摄像头';
        this.dialog.id = null;
        this.dialog.show = true;
      },
      edit(id) {
        this.dialog.title = '编辑摄像头';
        this.dialog.id = id;
        this.dialog.show = true;
      },
      del(id) {
        this.$confirm(
          '确认删除?',
          '提示',
          {
            type: 'warning'
          }
        ).then(() => {
          return ProjectService.delDevice(this.id, id);
        }).then(res => {
          return this.initDatas();
        }).then(res => {
          this.$message.success('删除成功');
        }).catch(() => {});
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.value = '';
        this.searchParams();
      }
    },
  }
</script>

<style lang="less" scoped>

</style>